import NewRelicService from "services/NewRelic";

const captureException = (err) => {
    NewRelicService.sendError(err);
}

const debug = function() {
    const params = window.location.search;

    if(params.toLowerCase().indexOf('jumbodebug=true') !== -1){
        for(let i = 0; i < arguments.length; i++){
            /* eslint-disable no-console */
            console.log(arguments[i]);
        }
    }
}

const Log = {
    captureException,
    debug
}

export default Log;
